(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ob-email-popup"] && !Shopify.designMode) return;
  try {
    
    (function () {
      var popup = document.querySelector('[data-ob-email-popup]');
      if (!popup) return;

      // Frequency cap via localStorage (cookie fallback if unavailable):
      //   ob_popup_subscribed      -> '1' once they submit, never shown again
      //   ob_popup_dismissed_until -> epoch ms; suppressed until then (30 days)
      var KEY_SUB = 'ob_popup_subscribed';
      var KEY_UNTIL = 'ob_popup_dismissed_until';
      var dismissDays = parseInt(popup.getAttribute('data-dismiss-days'), 10) || 30;
      var fallbackSec = parseInt(popup.getAttribute('data-delay'), 10) || 0; // time-on-page fallback; 0 = off
      var scrollFrac = (parseInt(popup.getAttribute('data-scroll-pct'), 10) || 55) / 100;
      var MIN_TIME_MS = 3000; // never fire in the first few seconds
      var loadedAt = Date.now();
      var opened = false;

      var store = {
        get: function (k) {
          try { return window.localStorage.getItem(k); } catch (e) {}
          var m = document.cookie.match('(^|;)\\s*' + k + '=([^;]+)');
          return m ? decodeURIComponent(m[2]) : null;
        },
        set: function (k, v) {
          try { window.localStorage.setItem(k, v); return; } catch (e) {}
          var d = new Date(); d.setTime(d.getTime() + 365 * 864e5);
          document.cookie = k + '=' + encodeURIComponent(v) + ';expires=' + d.toUTCString() + ';path=/;samesite=lax';
        }
      };

      function suppressed() {
        if (store.get(KEY_SUB)) return true;
        var until = parseInt(store.get(KEY_UNTIL) || '0', 10);
        return until && Date.now() < until;
      }

      // Return-trip after a successful submit: mark subscribed, don't open.
      if (popup.querySelector('.ob-popup__success')) {
        store.set(KEY_SUB, '1');
        return;
      }
      if (suppressed()) return;

      function open(reason) {
        if (opened || suppressed()) return;
        opened = true;
        popup.classList.add('is-open');
        popup.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
        var first = popup.querySelector('.ob-popup__input');
        if (first) setTimeout(function () { first.focus(); }, 80);
        if (window.dataLayer) window.dataLayer.push({ event: 'ob_email_popup_shown', reason: reason || 'unknown' });
        teardown();
      }
      function close(reason) {
        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        store.set(KEY_UNTIL, String(Date.now() + dismissDays * 864e5));
        if (window.dataLayer) window.dataLayer.push({ event: 'ob_email_popup_dismissed', reason: reason || 'unknown' });
      }

      // --- triggers: exit-intent (desktop) OR 60% scroll depth ---
      function onMouseOut(e) {
        if (Date.now() - loadedAt < MIN_TIME_MS) return;
        if (!e.relatedTarget && e.clientY <= 0) open('exit-intent');
      }
      function onScroll() {
        if (Date.now() - loadedAt < MIN_TIME_MS) return;
        var doc = document.documentElement;
        var max = (doc.scrollHeight - doc.clientHeight);
        if (max > 0 && (doc.scrollTop || window.scrollY) / max >= scrollFrac) open('scroll-depth');
      }
      function teardown() {
        document.removeEventListener('mouseout', onMouseOut);
        window.removeEventListener('scroll', onScroll);
      }
      document.addEventListener('mouseout', onMouseOut);
      window.addEventListener('scroll', onScroll, { passive: true });
      if (fallbackSec > 0) setTimeout(function () { open('fallback-timer'); }, fallbackSec * 1000);

      // --- close handlers ---
      popup.querySelectorAll('[data-ob-popup-close]').forEach(function (el) {
        el.addEventListener('click', function () { close('button'); });
      });
      var overlay = popup.querySelector('[data-ob-popup-overlay]');
      if (overlay) overlay.addEventListener('click', function () { close('overlay'); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && popup.classList.contains('is-open')) close('escape');
      });

      // Mark subscribed on submit so they're never re-prompted (the welcome
      // automation emails the unique single-use code).
      var form = popup.querySelector('.ob-popup__form');
      if (form) {
        form.addEventListener('submit', function () {
          store.set(KEY_SUB, '1');
          if (window.dataLayer) window.dataLayer.push({ event: 'ob_email_popup_submitted' });
        });
      }
    })();
  
  } catch(e) { console.error(e); }
})();
})();
